import React from 'react';
import { View } from 'react-native';
import { useThemeColors } from '@/lib/useThemeColors';

interface ScoreSparklineProps {
  data: number[];
  color?: string;
  height?: number;
  barWidth?: number;
  gap?: number;
  /** Hex alpha of the earlier bars (the last bar is solid). Default '40'. */
  restAlpha?: string;
}

export function ScoreSparkline({
  data,
  color,
  height = 28,
  barWidth = 4,
  gap = 2,
  restAlpha = '40',
}: ScoreSparklineProps) {
  const colors = useThemeColors();
  if (!data || data.length < 2) return null;

  const tint = color ?? colors.primary[500];
  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;

  return (
    <View style={{ flexDirection: 'row', alignItems: 'flex-end', height, gap }}>
      {data.map((value, index) => {
        const barHeight = ((value - min) / range) * height * 0.8 + height * 0.2;
        const isLast = index === data.length - 1;
        return (
          <View
            key={`spark-${index}`}
            style={{
              width: barWidth,
              height: barHeight,
              backgroundColor: isLast ? tint : `${tint}${restAlpha}`,
              borderRadius: barWidth / 2,
            }}
          />
        );
      })}
    </View>
  );
}
